module.exports = __webpack_public_path__ + "files/fcdf2b2b430b4aff795cd26dbc6959d7.png";